import { useState } from 'react';
import CardLayout from '../../../components/Layout/CardLayout';
import ReactDataTable from '../../../components/ReactDataTable/ReactDataTable';
import useFetch from '../../../hooks/useFetch';
import request from '../../../request/request';
import ModalLayout from '../../../components/Layout/ModalLayout';
import { formDataConverter } from '../../../utils/necessaryFunctions';
import EditButton from '../../../components/Button/EditButton';
import DeleteButton from '../../../components/Button/DeleteButton';
import DeleteModal from '../../../components/Modal/DeleteModal';
// eslint-disable-next-line import/no-useless-path-segments
import WhyChooseUsForm from './../../../components/Forms/WhyChooseUs/WhyChooseUsForm';

const WhyChooseUs = () => {
    const [modalOpen, setModalOpen] = useState('');
    const [selectedItem, setSelectedItem] = useState('');

    const { result, isLoading, setRefresh } = useFetch(() => request.getAll('why_choose_us'));

    const columns = [
        {
            name: 'Title',
            center: 'true',
            selector: (row) => row?.title,
        },
        // {
        //     name: 'Icon',
        //     width: '100px',
        //     cell: (row) => (
        //         <div>
        //             {row.icon_img && (
        //                 <img
        //                     style={{ width: '100%' }}
        //                     src={`${process.env.REACT_APP_UPLOAD_URL}/website/${row?.icon_img}`}
        //                     alt='side Img'
        //                 />
        //             )}
        //         </div>
        //     ),
        // },

        {
            name: 'Icon Class',
            wrap: true,
            center: 'true',
            selector: (row) => <i className={row?.icon_class} style={{ fontSize: '30px' }} />,
        },
        {
            name: 'Description',
            wrap: true,
            center: 'true',
            selector: (row) => row?.description,
        },
        // {
        //     name: 'Button Title',
        //     center: 'true',
        //     selector: (row) => row.button_title,
        // },
        {
            name: 'Status',
            center: 'true',
            selector: (row) => (row?.status === 1 ? 'Active' : 'InActive'),
        },
        {
            name: 'Active',
            cell: (row) => (
                <div>
                    <EditButton
                        onClick={() => {
                            setModalOpen('update');
                            setSelectedItem(row);
                        }}
                    />
                    <DeleteButton
                        onClick={() => {
                            setModalOpen('delete');
                            setSelectedItem(row);
                        }}
                    />
                </div>
            ),
        },
    ];

    // create new function

    const createNewWhyChooseUsHandler = (formValue) =>
        request.create('why_choose_us', formValue, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });

    // update

    const updateWhyChooseUsHandler = (formValue) => {
        // const formData = formDataConverter(formValue);
        const formData = formValue;

        return request.updateOne('why_choose_us', selectedItem?.id, formData, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });
    };

    // delete

    const deleteWhyChooseUsHandler = () =>
        request.delete('why_choose_us', selectedItem?.id, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });

    return (
        <CardLayout
            title='Why Choose Us'
            buttonTitle='Add New Why Choose Us'
            addButtonHandler={() => setModalOpen('create')}
        >
            <ReactDataTable data={result} columns={columns} pending={isLoading} />
            {/*= ============== create ===================== */}

            {modalOpen === 'create' && (
                <ModalLayout
                    isOpen={modalOpen === 'create'}
                    onClose={() => setModalOpen('')}
                    title='Create New Why Choose Us'
                    size='lg'
                >
                    <WhyChooseUsForm apiHandler={createNewWhyChooseUsHandler} />
                </ModalLayout>
            )}

            {/* ======================= update ========================== */}

            {modalOpen === 'update' && (
                <ModalLayout
                    isOpen={modalOpen === 'update'}
                    onClose={() => setModalOpen('')}
                    title='Update New Why Choose Us'
                    size='lg'
                >
                    <WhyChooseUsForm
                        apiHandler={updateWhyChooseUsHandler}
                        editData={selectedItem}
                    />
                </ModalLayout>
            )}

            {/* ======================= delete ========================== */}

            {modalOpen === 'delete' && (
                <DeleteModal
                    isOpen={modalOpen === 'delete'}
                    onClose={() => setModalOpen('')}
                    handleDelete={deleteWhyChooseUsHandler}
                />
            )}
        </CardLayout>
    );
};

export default WhyChooseUs;
